import { useTranslation } from "react-i18next";

import i18n from "i18next";

import { useContentSelectors } from "../../../../../store/content/content.selectors";
import { useFreeProxyData } from "../../../../../store/freeProxy/freeProxy.selectors";

import { getTranslatedCity } from "../../../../../utils/helpers/getTranslatedCity";

import {
  useExportData,
  useFilterState,
  useI18typeProxy,
} from "../../../../../hooks";

import { BoxWrapper } from "../../../../../components";
import Export from "../../../../../components/common/Export";
import { SelectAndSearch } from "../../../../../components/ui/SelectAndSearch/SelectAndSearch";
import { addStyles } from "./addStyles";
import GoogleCheckbox from "./components/GoogleCheckbox";

import {
  BoxContainerOne,
  BoxContainerTwo,
  CheckBoxLabel,
  CheckBoxWrapper,
  Title,
  WrapperContainer,
} from "./Filter.styled";

export const Filter = () => {
  const { t } = useTranslation();
  const currentLanguage = i18n.language;

  // const types = t("typeOfProxy", { returnObjects: true });
  const { types } = useI18typeProxy();

  const { allCountry } = useContentSelectors();

  const { cities, freeProxiesForExport } = useFreeProxyData();

  const newCities = cities
    ?.filter(el => el)
    ?.map(el => ({ id: el, name: getTranslatedCity(el, currentLanguage) }));

  const { txtData, exportData } = useExportData(freeProxiesForExport);

  const {
    selectedCountry,
    selectedCity,
    selectedType,
    selectedValue,
    setSelectedValue,
    setSelectedCountry,
    setSelectedCity,
    setSelectedType,
  } = useFilterState();

  const checkBoxData = [t("global.yes"), t("global.no")];

  const handleCheckboxChecked = value => {
    if (selectedValue === value) {
      setSelectedValue("");
    } else {
      setSelectedValue(value);
    }
  };

  const handleSelect = setter => event => {
    setter(event.target.value);
  };

  return (
    <BoxWrapper addStyles={addStyles}>
      <WrapperContainer>
        <BoxContainerOne>
          <Title>{t("freeProxyServer.filter.title")}</Title>

          <CheckBoxWrapper>
            <CheckBoxLabel>Google:</CheckBoxLabel>

            {checkBoxData.map((item, i) => (
              <GoogleCheckbox
                key={i}
                selectedValue={selectedValue}
                onChange={handleCheckboxChecked}
                label={item}
              />
            ))}
          </CheckBoxWrapper>
        </BoxContainerOne>

        <BoxContainerTwo>
          <SelectAndSearch
            selectName="name"
            data={allCountry}
            isLoading={false}
            placeholder={t("freeProxyServer.selectCountryPlaceholder")}
            handleChange={handleSelect(setSelectedCountry)}
            type="filter"
            showFlag={true}
            queryValue={selectedCountry}
            allOption={{
              name: t("global.allCountries"),
              englishName: -1,
            }}
            selectOption={"englishName"}
          />
          <SelectAndSearch
            selectName="name"
            data={newCities}
            isLoading={false}
            placeholder={t("freeProxyServer.selectCityPlaceholder")}
            handleChange={handleSelect(setSelectedCity)}
            type="filter"
            showFlag={false}
            queryValue={selectedCity}
            allOption={{ id: -1, name: t("global.allCities") }}
          />

          <SelectAndSearch
            selectName="name"
            data={types}
            isLoading={false}
            placeholder={t("freeProxyServer.selectTypePlaceholder")}
            handleChange={handleSelect(setSelectedType)}
            type="filter"
            showFlag={false}
            queryValue={selectedType}
            allOption={{ id: -1, name: t("global.allTypes") }}
          />
        </BoxContainerTwo>

        <Export txtData={txtData} exportData={exportData} />
      </WrapperContainer>
    </BoxWrapper>
  );
};
